<template>
  <v-row>
    <v-col cols="12">
      <text-field-like
        :value="serviceImplementation.name"
        label="名称"
        hide-details>
      </text-field-like>
    </v-col>
    <v-col cols="12">
      <text-field-like
        :value="serviceImplementation.description"
        placeholder="未設定"
        label="説明"
        hide-details>
      </text-field-like>
    </v-col>
    <v-col cols="12">
      <local-id-field
        :value="serviceImplementation.localId"
        label="内部ID"
        hide-details>
      </local-id-field>
    </v-col>
    <v-col cols="12">
      <text-field-like
        :value="serviceImplementation.remarks"
        placeholder="未設定"
        label="備考"
        multi-line
        hide-details>
      </text-field-like>
    </v-col>
  </v-row>
</template>

<script>
import TextFieldLike from "@/components/molecules/TextFieldLike.vue";
import LocalIdField from "@/components/molecules/LocalIdField.vue";

export default {
  name: 'ServiceImplementationDeleteForm',
  components: {
    TextFieldLike,
    LocalIdField
  },
  model: {
    prop: 'serviceImplementation'
  },
  props: {
    serviceImplementation: {
      type: Object,
      required: true
    },
    readonly: {
      type: Boolean,
      default: false
    }
  },
}
</script>
